
export const environment = {
	production: true,
	IDENTITY_PROVIDER: 'keycloak',
	keycloak: {
		url: 'https://stg.auth.drivesec.cn',
		realm: 'weseth',
		clientId: 'frontend-users-client'
	},
	aws: {
		region: '',
		userPoolId: '',
		userPoolWebClientId: ''
	},
	apiUrl: 'https://fhk436u88f.execute-api.cn-north-1.amazonaws.com.cn',
	appName: 'WESETH',
	captchaKey: '6Ldnr0EdAAAAAPoOZD0xQs0xIUMKlhHZDEC4xnQl',
	googleApiKey: 'AIzaSyA6F9LbJG5qoVbQMkAEQ_zDCcz_l9QMJ-w',
	appVersion: require('../../package.json').version + 'staging-cn-north-1'
};
